export default class Task {

  id = null;
  name = "";
  code = "";
  facilityName = "";
  inService = false;
  vandalism = false;
  description = '';
  facility = '';
  contact = '';
  externalContact = '';
  externalPhoneContact = '';
  accidentDate = '';
  appointmentDate = '';
  manager = '';
  externalId = '';
  category = ''
  company = ''

  constructor() {
  }
}
